// @mui icons
import Icon from "@mui/material/Icon";

// Pages
import UserProfile from "./user/profile";
import Agents from "./agents";
import WalletPage from "./wallet";
import Users from "./users";
import AccountProfile from "./account";
import BillingPage from "./billing";
import AgentBenefitsPage from "./agent_benefits";
import WhatsappHomePage from "./comms_os/wacc";

const routes = [
  {
    type: "group",
    title: "Whatsapp Center",
    icon: "forum",
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "wacc",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/wacc",
    component: <WhatsappHomePage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Agents",
    key: "agents",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/agents",
    component: <Agents />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Benefits",
    key: "agent-benefits",
    icon: <Icon fontSize="small">money</Icon>,
    route: "/agent-benefits",
    component: <AgentBenefitsPage />,
    secure: true,
  },
  {
    type: "group",
    title: "Accounts & Billing",
    icon: "domain",
  },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/billing",
    component: <BillingPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Wallet",
    key: "wallet",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/wallet",
    component: <WalletPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Account",
    key: "account",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/account",
    component: <AccountProfile />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <UserProfile />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <Users />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
];

export default routes;
